import React from 'react'

export default function TaskRecipientsList({ defaultValue, onChange }) {
    const RECIPIENTS = [
        { key: 'Patient', hr: 'Patient' },
        { key: 'Clinician', hr: 'Clinician' },
        { key: 'Administrator', hr: 'Administrator' },
        { key: 'All Patients in Facility', hr: 'All Patients in Facility' },
        { key: 'All Clinicians in Facility', hr: 'All Clinicians in Facility' },
        { key: 'All Administrators in Facility', hr: 'All Administrators in Facility' },
        { key: 'User', hr: 'User' },
    ]
    return (
        <select
            onChange={(e) => onChange(e.target.value)}
            className='form-control form-control-sm'>
            <option></option>
            {RECIPIENTS.map(r => <option value={r.key} selected={defaultValue && defaultValue === r.key ? "selected" : ""}>{r.hr}</option>)}
        </select>
    )
}
